export default __webpack_public_path__ + "static/media/oldRec.ad69b39b.jpg";